//
// File: ShellSharedLibraries.ts
// Description: A central location to store the shared libraries record
// used by module-federation.config.ts of each microfrontend/plugin
// Copyright: Broadlume 2024
//

import { SharedLibraryConfig } from '@nx/webpack';

/**
 * A central location to store the shared libraries record
 * used by module-federation.config.ts of each microfrontend/plugin
 */
export const ShellSharedLibraries: Record<string, SharedLibraryConfig> = {
  react: {
    singleton: true,
    eager: true,
    requiredVersion: '18.3.1',
  } as SharedLibraryConfig,
  'react-dom': {
    singleton: true,
    eager: true,
    requiredVersion: '18.3.1',
  } as SharedLibraryConfig,
  'react-router-dom': {
    singleton: true,
    eager: true,
    requiredVersion: '6.28.0',
  } as SharedLibraryConfig,
  'react-singleton-context': {
    singleton: true,
    eager: true,
    requiredVersion: '1.0.5',
  } as SharedLibraryConfig,
  '@broadlume/shellcore': {
    singleton: true,
    eager: true,
    requiredVersion: '0.0.60',
  } as SharedLibraryConfig,
  '@broadlume/willow-ui': {
    singleton: true,
    eager: true,
    requiredVersion: '1.0.38',
  } as SharedLibraryConfig,
  '@tanstack/react-query': {
    singleton: true,
    eager: true,
    requiredVersion: '5.90.2',
  },
  i18next: {
    singleton: true,
    eager: true,
    requiredVersion: '26.0.5',
  },
  'react-i18next': {
    singleton: true,
    eager: true,
    requiredVersion: '17.0.3',
  },
  '@sentry/react': {
    singleton: true,
    eager: true,
    requiredVersion: '10.39.0',
  } as SharedLibraryConfig,
};
